import React from 'react';

import { Button } from '@BICE_Vida/components';

import { Modal, ModalBody, ModalContent } from '@BICE_Vida/scp-components';

import { TODO_LIST_ICON_GREY } from '@/utils/assets';

import styles from './RequirementsModal.module.scss';
import { landingText } from '@/utils/generalTexts';

type RequirementsModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

function RequirementsModal({ isOpen, setIsOpen }: RequirementsModalProps) {
  const onClickFunction = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <Modal isOpen={isOpen} onClose={onClickFunction} closeOnOverlay classNameModal={styles.modal}>
        <ModalBody
          img={TODO_LIST_ICON_GREY}
          className={styles.modal_body}
          content={
            <ModalContent
              title={landingText.hero.modal.title}
              className={styles.text_modal_content}
            >
              <div className={styles.text_modal_body}>
                <ul>
                  {landingText.hero.modal.requirements.map((requirement, index) => (
                    <li key={index}>{requirement}</li>
                  ))}
                </ul>
              </div>
            </ModalContent>
          }
        />
        <div className={styles.container_buttons}>
          <Button
            text={landingText.hero.modal.button}
            variant="primary"
            size="large"
            onClick={onClickFunction}
          />
        </div>
      </Modal>
    </div>
  );
}

export default RequirementsModal;
